import { render, staticRenderFns } from "./BarMultid.vue?vue&type=template&id=5efdd6b9&scoped=true&"
import script from "./BarMultid.vue?vue&type=script&lang=js&"
export * from "./BarMultid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efdd6b9",
  null
  
)

export default component.exports